// DashboardService.js
import api from '../../utils/ApiConfig';
// Fetch all KPI from the database
const fetchKpiData = async (periodData) => {
    try {
      const response = await api.get(`/kpi/panier`, { params: periodData });
      if (response.data.error) {
        throw new Error(response.data.error); // Gérer l'erreur en fonction de la structure de réponse
      }
      return response.data;  // retourner les informations
    } catch (error) {
      console.error('Error saving Kpi data:', error);
      throw error;
    }
  }

// Fetch pending and urgent supplier orders
const fetchPendingSupplierOrders = async () => {
  try {
    // Récupère les commandes avec statuts : 4 (validation), 3 (préparation), 1 (livraison)
    // Filtre : toutes les commandes en retard + aujourd'hui + demain
    // Tri par date de livraison croissante
    const response = await api.get(`/fo/getPendingUrgentSupplierOrders`);
    return response.data;
  } catch (error) {
    console.error('Error fetching pending supplier orders:', error);
    throw error;
  }
}

// Fetch all delivery drivers positions (geolocation)
const fetchLivreursPositions = async () => {
  try {
    const response = await api.get(`/admin/livreurs/positions`);
    if (response.data.error) {
      throw new Error(response.data.error);
    }
    return response.data;
  } catch (error) {
    console.error('Error fetching livreurs positions:', error);
    throw error;
  }
}

// Manutentions laissées à 0 faute de chiffrage : tant qu'elles ne sont pas
// confirmées, c'est ce 0 qui sera facturé à la clôture, sans retour possible.
const fetchManutentionsAConfirmer = async () => {
  const response = await api.get('/bo/manutentions-a-confirmer');
  return response.data;
}

// Manutentions chiffrées par les livreurs depuis la fiche reçue par SMS.
// Une fois chiffrées, elles quittent le carton ci-dessus : c'est ici qu'on les
// relit, tant que la facture n'est pas émise.
const fetchManutentionsLivreurs = async (jours = 30, validees = false) => {
  const response = await api.get(`/bo/manutentions-livreurs?jours=${jours}&validees=${validees ? 1 : 0}`);
  return response.data;
}

// Visa de relecture : « relu, c'est bon ». Sans effet sur le montant, deja
// applique — il sort la ligne du carton, qui reste une file d'attente.
const validerManutentionLivreur = async (idCommande) => {
  const response = await api.post(`/bo/commandes-fournisseur/${idCommande}/manutention/valider`);
  return response.data;
}

// Ou en est le mois : objectif de CA et charges couvertes. Tous les nombres —
// objectif, pourcentages, projection — viennent du serveur : les recopier ici
// garantirait qu'ils divergent du recap mensuel, qui annonce le meme objectif.
const fetchObjectifMois = async () => {
  const response = await api.get('/bo/objectif-mois');
  return response.data;
}

// Clients presents sur le site en ce moment. La presence est horodatee cote
// serveur a chaque requete authentifiee ; ici on ne fait que lire.
const fetchClientsEnLigne = async () => {
  const response = await api.get('/bo/clients-en-ligne');
  return response.data;
}

// Livraisons d'aujourd'hui et du prochain jour de livraison : comptées au serveur.
const fetchLivraisonsJours = async () => {
  const response = await api.get('/bo/livraisons-jours');
  return response.data;
}

// Export methods ************************************************************
export {fetchKpiData, fetchPendingSupplierOrders, fetchLivreursPositions, fetchManutentionsAConfirmer, fetchManutentionsLivreurs, validerManutentionLivreur, fetchClientsEnLigne, fetchObjectifMois, fetchLivraisonsJours}